import { connect } from 'react-redux';
import { getHuggg, hasPrepaidCardVoucher } from 'redux/modules/huggg';
import Footer from './Footer';

const mapStateToProps = (state) => {
  return {
    huggg: getHuggg(state),
    hasPrepaidCardVoucher: hasPrepaidCardVoucher(state),
  };
};

export default connect(mapStateToProps)(Footer);
